import { styled } from '@mui/material/styles';

export const PsdGrid = styled('div')(() => ({
  display: 'grid',
  gridAutoColumns: 'auto',
  gridAutoRows: '48px',
  alignContent: 'stretch',
}));

interface PsdGridRowProps {
  animate?: number;
  status?: 'highlight' | 'default';
}

export const PsdGridRow = styled('div')<PsdGridRowProps>`
  display: grid;
  grid-template-columns: 44px 1fr 1fr 38px;
  grid-column-gap: 0;
  border-bottom: ${(p) => `1px solid ${p.theme.palette.divider}`};
  animation: ${(p) => p.animate === 1 && 'addHighlight 1s'};
  background-color: ${(p) =>
    p.status === 'highlight' ? p.theme.palette.info.light : 'transparent'};

  @keyframes addHighlight {
    0% {
      background-color: transparent;
    }
    50% {
      background-color: ${(p) => p.theme.palette.success.light};
    }
    100% {
      background-color: transparent;
    }
  }
`;

export const PsdCheckboxCell = styled('div')(() => ({
  gridColumn: '1/2',
  alignSelf: 'center',
}));

export const PsdSizeCell = styled('div')(({ theme }) => ({
  gridColumn: '2/3',
  alignSelf: 'center',
  marginRight: theme.spacing(2),
}));

export const PsdPercentCell = styled('div')(({ theme }) => ({
  gridColumn: '3/4',
  alignSelf: 'center',
  paddingRight: theme.spacing(2),
}));

export const PsdSpanValuesCell = styled('div')(({ theme }) => ({
  gridColumn: '2/4',
  alignSelf: 'center',
  paddingRight: theme.spacing(2),
}));

export const PsdActionCell = styled('div')(() => ({
  gridColumn: '4/5',
  alignSelf: 'center',
}));
